module.exports = __webpack_public_path__ + "static/media/3_Sign_Up.2e5762e3.jpg";